<smrts-dialog [title]="data.titulo" [hasFootnote]="true">

  @if (lancamentosOrdenados.length === 0) {
    <p class="lista-vazia">Nenhum lançamento nesta categoria.</p>
  }

  @if (lancamentosOrdenados.length > 0) {
    <p-table [value]="lancamentosOrdenados" responsiveLayout="scroll" sortMode="multiple">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="data">Data<p-sortIcon field="data" /></th>
          <th pSortableColumn="descricao">{{ tituloColunaLancamento }}<p-sortIcon field="descricao" /></th>
          <th pSortableColumn="valor">Valor<p-sortIcon field="valor" /></th>
          @if (data.cardEhBanco !== undefined) {
            <th></th>
          }
        </tr>
      </ng-template>
      <ng-template #body let-lancamento>
        <tr>
          <td>{{ lancamento.data | date:'dd/MM/yyyy' }}</td>
          <td>{{ lancamento.descricao }}</td>
          <td [ngClass]="{'red-text': lancamento.valor < 0 }">{{ lancamento.valor | currency:'BRL' }}</td>
          @if (data.cardEhBanco !== undefined) {
            <td>
              <button mat-icon-button class="visibility-btn" [disabled]="!lancamento.conciliado"
                [matTooltip]="lancamento.conciliado ? 'Ver correspondência' : 'Lançamento não está mais conciliado'"
                (click)="verCorrespondenciaClick(lancamento)">
                <mat-icon>visibility</mat-icon>
              </button>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  }

  <div footnote class="inline-element footnote">
    <button class="white-text-button" mat-flat-button [mat-dialog-close]="true">
      Fechar
    </button>
  </div>
</smrts-dialog>
